<ld-base-modal
  *transloco="let t"
  [title]="t('helocDrawFundsTitle', { fallback: 'Request Funds' })"
  [size]="'medium'"
  (closeModal)="onClose()"
>
  <ng-container modal-content>
    <div id="draw-funds-modal-content" class="flex flex-col gap-4 p-6">
      <p id="draw-funds-available-credit" class="text-sm text-ld-neutral-600">
        {{ t('helocDrawFundsAvailableCredit', { fallback: 'Available Credit' }) }}:
        <span class="font-semibold text-ld-neutral">{{ data().availableCredit | currency }}</span>
      </p>

      <p id="draw-funds-description" class="text-sm text-ld-neutral-600">
        {{ t('helocDrawFundsDescription', { fallback: 'Submit a request to draw funds from your HELOC account.' }) }}
      </p>
    </div>
  </ng-container>

  <ng-container modal-footer>
    <div id="draw-funds-modal-footer" class="flex justify-end gap-3 px-6 pb-6">
      <button id="draw-funds-cancel-btn" type="button" class="btn-outline-ld-purple cursor-pointer" (click)="onClose()">
        {{ t('commonButtonsCancel', { fallback: 'Cancel' }) }}
      </button>
      <button
        id="draw-funds-submit-btn"
        type="button"
        class="btn-primary-ld-purple cursor-pointer"
        (click)="onSubmit()"
      >
        {{ t('helocDrawFundsSubmit', { fallback: 'Submit Request' }) }}
      </button>
    </div>
  </ng-container>
</ld-base-modal>
